import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Zap } from 'lucide-react';
import { useCurrency } from '../utils/currency';
export function UrgencySection() {
  const {
    formatPrice
  } = useCurrency();
  return <section className="w-full bg-[#1A1A1A] py-14 px-4 sm:px-6 lg:px-8" data-id="element-389">
      <div className="max-w-2xl mx-auto text-center" data-id="element-390">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-5" data-id="element-391">
          <div className="flex justify-center" data-id="element-392">
            <div className="w-12 h-12 rounded-full bg-[#0B6B3A]/20 flex items-center justify-center" data-id="element-393">
              <Clock className="w-6 h-6 text-[#DCF8C6]" data-id="element-394" />
            </div>
          </div>

          <h2 className="text-2xl sm:text-3xl font-bold text-white" data-id="element-395">
            Este precio es de lanzamiento y validación.
          </h2>

          <div className="space-y-3 text-[#9CA3AF] text-lg leading-relaxed" data-id="element-396">
            <p data-id="element-397">No es permanente.</p>
            <p data-id="element-398">
              Cuando termine esta fase, el precio sube y los bonos se venden por
              separado.
            </p>
            <p className="text-white font-semibold" data-id="element-399">
              Si estás leyendo esto ahora, todavía estás a tiempo.
            </p>
          </div>

          <div className="inline-flex items-center gap-2 bg-[#0B6B3A]/20 border border-[#0B6B3A]/40 rounded-full px-5 py-2.5 mt-4" data-id="element-400">
            <Zap className="w-4 h-4 text-[#DCF8C6]" data-id="element-401" />
            <span className="text-[#DCF8C6] text-sm font-semibold" data-id="element-402">
              Precio actual: {formatPrice(6.39)} (lanzamiento)
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}